(() => {
  const init = () => {
    const dataNode = document.getElementById('ozeli-discovery-data');
    if (!dataNode || dataNode.dataset.ready) return;
    dataNode.dataset.ready = 'true';
    const { products, current, text } = JSON.parse(dataNode.textContent);
    const byId = new Map(products.map(p => [String(p.id), p]));
    const read = key => { try { const v = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v.filter(x => typeof x === 'string').slice(0, 60) : []; } catch { return []; } };
    const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } };
    let saved = read('ozeli-favourites-v1');
    const notice = document.getElementById('ozeli-discovery-status');
    const say = message => { notice.textContent = message; };
    const el = (tag, className, content) => { const n = document.createElement(tag); if (className) n.className = className; if (content !== undefined) n.textContent = content; return n; };
    const saveButton = p => {
      const b = el('button', 'oz-i-save'); b.type = 'button'; b.dataset.ozSave = p.id;
      b.setAttribute('aria-label', text.save + ': ' + p.title); return b;
    };
    const sync = () => {
      document.querySelectorAll('[data-oz-save]').forEach(b => {
        const active = saved.includes(b.dataset.ozSave); b.setAttribute('aria-pressed', String(active)); b.textContent = active ? text.saved : text.save;
      });
      document.querySelectorAll('[data-oz-count]').forEach(n => n.textContent = saved.filter(id => byId.has(id)).length);
    };
    const card = p => {
      const article = el('article', 'oz-i-card'); const link = el('a'); link.href = p.url;
      if (p.image) { const img = el('img'); img.src = p.image; img.alt = p.title; img.loading = 'lazy'; img.width = 500; img.height = 625; link.append(img); }
      link.append(el('h3', '', p.title), el('p', '', p.price));
      if (!p.available) link.append(el('span', 'oz-i-muted', text.sold_out));
      article.append(link, saveButton(p)); return article;
    };
    const render = (target, items, empty) => {
      if (!target) return; target.replaceChildren();
      if (!items.length) target.append(el('p', 'oz-i-muted', empty));
      else items.forEach(p => target.append(card(p)));
      sync();
    };
    const wishlist = document.getElementById('ozeli-wishlist');
    const renderSaved = () => render(wishlist.querySelector('[data-oz-saved-list]'), saved.map(id => byId.get(id)).filter(Boolean), text.empty_saved);
    let opener;
    let closingWishlist=false;
    const closeWishlist=()=>{if(closingWishlist)return; if(matchMedia('(prefers-reduced-motion: reduce)').matches){wishlist.close();return;} closingWishlist=true; const motion=wishlist.animate([{opacity:1,transform:'translateY(0) scale(1)'},{opacity:0,transform:'translateY(12px) scale(.985)'}],{duration:180,easing:'ease-in'});motion.finished.finally(()=>{wishlist.close();closingWishlist=false;});};
    document.addEventListener('click', event => {
      const b = event.target.closest('[data-oz-save]');
      if (b) {
        const id = b.dataset.ozSave; const was = saved.includes(id);
        const next = was ? saved.filter(x => x !== id) : [id, ...saved].slice(0,60);
        if (!write('ozeli-favourites-v1', next)) { say(text.storage_error); return; }
        saved = next; sync(); if (wishlist.open) renderSaved(); say(was ? text.removed : text.added);
      }
      const open = event.target.closest('[data-oz-open-wishlist]');
      if (open) { opener = open; renderSaved(); wishlist.showModal(); }
      if (event.target.closest('[data-oz-close-wishlist]')) closeWishlist();
    });
    wishlist.addEventListener('cancel', event=>{event.preventDefault();closeWishlist();});
    wishlist.addEventListener('close', () => opener?.focus());
    wishlist.addEventListener('click', event => { if (event.target === wishlist) { const r = wishlist.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeWishlist(); } });
    window.addEventListener('storage', event => { if (event.key === 'ozeli-favourites-v1') { saved = read(event.key); sync(); if (wishlist.open) renderSaved(); } });
    if (current && byId.has(String(current))) {
      const p = byId.get(String(current)); const mount = document.querySelector('.product-details h1, .product-details .h1, main h1');
      if (mount && !document.querySelector('[data-oz-product-save]')) { const b = saveButton(p); b.dataset.ozProductSave = ''; mount.insertAdjacentElement('afterend', b); }
    }
    let recent = read('ozeli-recent-v1');
    const recentItems = recent.filter(id => id !== String(current)).map(id => byId.get(id)).filter(Boolean).slice(0, 6);
    const recentSection = document.getElementById('ozeli-recent');
    if (recentItems.length && recentSection) { recentSection.hidden = false; render(recentSection.querySelector('[data-oz-recent-list]'), recentItems, ''); }
    if (current) write('ozeli-recent-v1', [String(current), ...recent.filter(id => id !== String(current))].slice(0, 12));
    document.querySelector('[data-oz-clear-recent]')?.addEventListener('click', () => { write('ozeli-recent-v1', current ? [String(current)] : []); recentSection.hidden = true; });
    const natural = /pillar|loen|bergen|voss|asker|oslo|flåm|østmarka/i;
    const sculptural = /bue|aurland|tromsø|pilz|solvik|rille/i;
    const colourful = /moss|knopp|solvik|tromsø/i;
    const lamps = products.filter(p => /lamp/i.test(p.title) && p.available);
    const quiz = document.getElementById('ozeli-lamp-quiz');
    quiz?.addEventListener('submit', event => {
      event.preventDefault(); const answers = new FormData(quiz);
      const style = answers.get('style'); const room = answers.get('room'); const budget = Number(answers.get('budget'));
      const withinBudget = lamps.filter(p => !budget || p.amount <= budget);
      const ranked = withinBudget.map(p => {
        let score = 0;
        if (style === 'natural' && natural.test(p.title)) score += 5;
        if (style === 'sculptural' && sculptural.test(p.title)) score += 5;
        if (style === 'colourful' && colourful.test(p.title)) score += 5;
        if (room === 'bedside' && /bedside|tromsø|aurland|rille|moss|knopp/i.test(p.title)) score += 3;
        if (room === 'living' && /voss|pillar|asker|flåm|østmarka|bergen/i.test(p.title)) score += 3;
        if (room === 'desk' && /bue|asker|rille|aurland/i.test(p.title)) score += 3;
        return {p, score};
      }).sort((a,b) => b.score - a.score);
      const results = document.getElementById('ozeli-quiz-results'); results.hidden = !!quiz.closest('.oz-q');
      render(results.querySelector('[data-oz-quiz-list]'), ranked.slice(0,3).map(x=>x.p), text.no_match);
      results.querySelector('[data-oz-result-note]').textContent = ranked.length ? text.matches_note : text.no_match;
      results.focus();
    });
    const moods = {
      cosy: p => /lamp|candle|blanket|bedding|incense|humidifier/i.test(p.title),
      quiet: p => /vase|tray|incense|humidifier|blanket/i.test(p.title),
      sculptural: p => /vase|bue|asker|aurland|voss|pilz|solvik|tromsø/i.test(p.title)
    };
    const moodRoot = document.querySelector('[data-oz-moods]');
    const chooseMood = key => {
      const choices = products.filter(p => p.available && moods[key](p)).slice(0, 8);
      moodRoot.querySelectorAll('[data-oz-mood]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ozMood === key)));
      render(moodRoot.querySelector('[data-oz-mood-list]'), choices, text.no_match);
      moodRoot.querySelector('[data-oz-mood-status]').textContent = text.mood_updated;
    };
    moodRoot?.addEventListener('click', event => { const b = event.target.closest('[data-oz-mood]'); if (b) chooseMood(b.dataset.ozMood); });
    if (moodRoot) chooseMood('cosy');
    const decorateCards = () => {
      document.querySelectorAll('.ozeli-new__card, product-card').forEach(article => {
        if (article.querySelector('[data-oz-save]')) return;
        const link = article.querySelector('a[href*="/products/"]');
        const path = link ? new URL(link.href, location.origin).pathname : '';
        const p = products.find(p => p.url.split('?')[0] === path);
        if (p) article.append(saveButton(p));
      });
      sync();
    };
    decorateCards();
    const main = document.querySelector('main');
    if (main) new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(n => n.nodeType === 1 && (n.matches('product-card') || n.querySelector('product-card'))))) decorateCards();
    }).observe(main, { childList: true, subtree: true });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
 const setup=()=>{
 document.querySelectorAll('.oz-q-disclosure, .oz-review-disclosure').forEach(details=>{
 if(details.dataset.ozAnimated)return;details.dataset.ozAnimated='true';
 const summary=details.querySelector(':scope > summary');if(!summary)return;
 let wanted=details.open,animation,serial=0;summary.setAttribute('aria-expanded',String(wanted));
 summary.addEventListener('click',async event=>{
 event.preventDefault();wanted=!wanted;const ticket=++serial;const before=details.getBoundingClientRect().height;animation?.cancel();
 summary.setAttribute('aria-expanded',String(wanted));
 if(matchMedia('(prefers-reduced-motion: reduce)').matches){details.open=wanted;details.style.overflow='';return;}
 details.open=true;
 const style=getComputedStyle(details),borders=parseFloat(style.borderTopWidth)+parseFloat(style.borderBottomWidth);
 const target=wanted?details.scrollHeight+borders:summary.getBoundingClientRect().height+borders;
 details.style.overflow='clip';
 animation=details.animate([{height:before+'px'},{height:target+'px'}],{duration:360,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
 try{await animation.finished;}catch{}if(ticket!==serial)return;
 details.open=wanted;animation.cancel();details.style.overflow='';
 });
 const feedback=details.querySelector('[data-oz-review-feedback]');
 if(feedback){details.open=true;wanted=true;summary.setAttribute('aria-expanded','true');feedback.focus({preventScroll:true});details.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});}
 });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
})();